import axios from 'axios'
import ParamUtils from '@/core/utils/ParamUtils'

const BASE_LEGADO_URL = '/compra-direta/api/v1/comprador/compras-diretas/legados'

class LegadoApiClient {

    async buscarListagemProcesso(filtro) {
        return await axios.get(`${BASE_LEGADO_URL}?${ParamUtils.ObjectToParams(filtro)}`)
    }

    async buscarProcessoPorId(processoAquisicaoId) {
        return await axios.get(`${BASE_LEGADO_URL}/${processoAquisicaoId}`)
    }

    async buscarExecucoesPorProcesso(processoAquisicaoId) {
        return await axios.get(`${BASE_LEGADO_URL}/${processoAquisicaoId}/execucoes`)
    }

    async buscarItensLotes(processoAquisicaoId, execucaoId) {
        return await axios.get(`${BASE_LEGADO_URL}/${processoAquisicaoId}/execucoes/${execucaoId}/itens-lotes`)
    }

    async buscarResultadoExecucao(processoAquisicaoId, execucaoId) {
        return await axios.get(`${BASE_LEGADO_URL}/${processoAquisicaoId}/execucoes/${execucaoId}/resultados`)
    }

    async baixarRelatorioPropostasItemLoteLegado(processoAquisicaoId, execucaoId, id, tipo) {
        return await axios.get(`${BASE_LEGADO_URL}/${processoAquisicaoId}/execucoes/${execucaoId}/itens-lotes/${id}/propostas-legado?tipo=${tipo}`,
            {
                responseType: 'arraybuffer'
            })
    }
}

export default new LegadoApiClient()
